import { useState } from 'react';
import { Link } from "react-router-dom";
import './index.scss'
import AnimatedLetters from "../AnimatedLetters";
import Loader from 'react-loaders';
import Newsletter from '../Newsletter';

const Home = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const headlineArray = ['P', 'r', 'o', 'd', 'u', 'c', 't', 'i', 'o', 'n', '-', 'R', 'e', 'a', 'd', 'y', ' ', 'i', 'O', 'S', ' ', 'A', 'p', 'p', 's']

    setTimeout(() => { setLetterClass('text-animate-hover') }, 4000)

    return (
        <>
            <div className="container home-page">
                {/* Hero Section */}
                <div className="text-zone hero-section">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={headlineArray}
                            idx={1} />
                    </h1>
                    <p className="hero-subtitle">for Health, Fitness, and AI Startups</p>
                    <h2 className="subheadline">
                        Native Swift development. From MVP to App Store in 4–8 weeks. Fixed-price packages starting at $15k.
                    </h2>
                    <p className="proof-line">
                        AI chat app with on-device ML • Health & productivity tools
                    </p>
                    <div className="hero-buttons">
                        <Link to="/pricing" className='flat-button primary'>VIEW iOS PACKAGES & PRICING</Link>
                        <Link to="/portfolio" className='flat-button secondary'>SEE OUR WORK</Link>
                    </div>
                </div>

                {/* Recent iOS Work Section */}
                <section className="ios-work-section">
                    <h2 className="section-heading">Recent iOS Work</h2>

                    <div className="work-cards">
                        {/* My-Advisor Card */}
                        <div className="work-card">
                            <div className="work-card-image">
                                <div className="image-placeholder">
                                    <span>My-Advisor</span>
                                </div>
                            </div>
                            <div className="work-card-content">
                                <h3>My-Advisor – Private AI Chat App</h3>
                                <p className="work-description">
                                    Built for privacy-conscious users who want AI without sending data to servers.
                                    On-device Core ML model, voice + text input, zero server calls. Complete privacy.
                                </p>
                                <p className="tech-stack">
                                    <strong>Tech Stack:</strong> SwiftUI, Core ML, Speech framework, SwiftData
                                </p>
                                <Link to="/portfolio/my-advisor" className="case-study-link">
                                    View Case Study →
                                </Link>
                            </div>
                        </div>

                        {/* Readdy Card */}
                        <div className="work-card">
                            <div className="work-card-image">
                                <div className="image-placeholder">
                                    <span>Readdy</span>
                                </div>
                            </div>
                            <div className="work-card-content">
                                <h3>Readdy – Reading Habit Tracker</h3>
                                <p className="work-description">
                                    Built for readers who want to build consistent habits without complex tracking.
                                    One-tap logging, streak system, progress badges. 4.9-star rating.
                                </p>
                                <p className="tech-stack">
                                    <strong>Tech Stack:</strong> SwiftUI, SwiftData, achievement system, custom UI animations
                                </p>
                                <Link to="/portfolio/readdy-app" className="case-study-link">
                                    View Case Study →
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* What I Build Section */}
                <section className="what-i-build-section">
                    <h2 className="section-heading">What We Build</h2>

                    <div className="industry-grid">
                        <div className="industry-card">
                            <span className="industry-icon fitness-icon"></span>
                            <h4>Health & Fitness</h4>
                            <p>Workout tracking, habit formation, wellness tools</p>
                        </div>
                        <div className="industry-card">
                            <span className="industry-icon ai-icon"></span>
                            <h4>AI/ML Utilities</h4>
                            <p>On-device intelligence, smart assistants, productivity</p>
                        </div>
                        <div className="industry-card">
                            <span className="industry-icon robotics-icon"></span>
                            <h4>Robotics Integration</h4>
                            <p>iOS interfaces for hardware, IoT control apps</p>
                        </div>
                        <div className="industry-card">
                            <span className="industry-icon social-icon"></span>
                            <h4>Social & Utility</h4>
                            <p>Chat, content sharing, connection tools</p>
                        </div>
                    </div>

                    <div className="my-approach">
                        <h3>Our Approach</h3>
                        <ul>
                            <li>Native Swift/SwiftUI (no cross-platform compromises)</li>
                            <li>Clean architecture that scales</li>
                            <li>Privacy-first (on-device when possible)</li>
                            <li>Polished UI that feels premium</li>
                        </ul>
                    </div>
                </section>
                <Newsletter />
            </div>
            <Loader type="ball-scale-multiple" ></Loader>
        </>
    )
}
export default Home